import { render, staticRenderFns } from "./FluentPrintIcon.vue?vue&type=template&id=ed5768b4"
import script from "./FluentPrintIcon.vue?vue&type=script&lang=ts"
export * from "./FluentPrintIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports